import { render, staticRenderFns } from "./AddLTable.vue?vue&type=template&id=93968b72&scoped=true"
import script from "./AddLTable.vue?vue&type=script&lang=js"
export * from "./AddLTable.vue?vue&type=script&lang=js"
import style0 from "./AddLTable.vue?vue&type=style&index=0&id=93968b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93968b72",
  null
  
)

export default component.exports